/**
 * 系统配置store
 */
import {
  // i18n
  APP_LANGUAGE,
} from '@/store/mutation-types';

// import dbUser from '@/api/system/user';
import auth from '@/utils/auth';
import { loadLanguageAsync } from '@/i18n';

import config from '@/config/defaultSettings';

const app = {
  namespaced: true,
  state: {
    sidebar: config.sidebarOpened,
    device: 'desktop',
    theme: 'light',
    layout: config.layout,
    contentWidth: '',
    fixedHeader: config.fixedHeader,
    fixSiderbar: config.fixSiderbar,
    autoHideHeader: config.autoHideHeader,
    color: null,
    weak: config.colorWeak,
    multiTab: config.multiTab,
    searchMenu: config.searchMenu,
    navMenu: config.navMenu,
    permission: config.permission,
    showChangeColor: config.showChangeColor,
    showChangeLanguage: config.showChangeLanguage,
    showTips: config.showTips,
    // 切换语言
    lang: auth.getLocal(),
  },
  mutations: {
    SET_SIDEBAR_TYPE: (state, type) => {
      state.sidebar = type;
    },
    CLOSE_SIDEBAR: (state) => {
      state.sidebar = false;
    },
    TOGGLE_DEVICE: (state, device) => {
      state.device = device;
    },
    TOGGLE_THEME: (state, theme) => {
      state.theme = theme;
    },
    TOGGLE_LAYOUT_MODE: (state, layout) => {
      state.layout = layout;
    },
    TOGGLE_FIXED_HEADER: (state, fixed) => {
      state.fixedHeader = fixed;
    },
    TOGGLE_FIXED_SIDERBAR: (state, fixed) => {
      state.fixSiderbar = fixed;
    },
    TOGGLE_FIXED_HEADER_HIDDEN: (state, show) => {
      state.autoHideHeader = show;
    },
    TOGGLE_CONTENT_WIDTH: (state, type) => {
      state.contentWidth = type;
    },
    TOGGLE_COLOR: (state, color) => {
      state.color = color;
    },
    TOGGLE_WEAK: (state, flag) => {
      state.weak = flag;
    },
    TOGGLE_MULTI_TAB: (state, bool) => {
      state.multiTab = bool;
    },
    TOGGLE_SEARCH_MENU: (state, bool) => {
      state.searchMenu = bool;
    },
    TOGGLE_PERMISSION: (state, bool) => {
      state.permission = bool;
    },
    TOGGLE_NAV_MENU: (state, bool) => {
      state.navMenu = bool;
    },

    TOGGLE_SHOW_CHANGE_COLOR: (state, bool) => {
      state.showChangeColor = bool;
    },

    TOGGLE_SHOW_CHANGE_LANGUAGE: (state, bool) => {
      state.showChangeLanguage = bool;
    },
    TOGGLE_SHOW_TIPS: (state, bool) => {
      state.showTips = bool;
    },

    /**
     * 设置语言
     * @param {*} state
     * @param {*} lang
     */
    [APP_LANGUAGE](state, lang) {
      state.lang = lang;
      auth.setLocal(lang);
    },
  },
  actions: {
    setSidebar({ commit }, type) {
      commit('SET_SIDEBAR_TYPE', type);
    },
    CloseSidebar({ commit }) {
      commit('CLOSE_SIDEBAR');
    },
    ToggleDevice({ commit }, device) {
      commit('TOGGLE_DEVICE', device);
    },
    ToggleTheme({ commit }, theme) {
      commit('TOGGLE_THEME', theme);
    },
    ToggleLayoutMode({ commit }, mode) {
      commit('TOGGLE_LAYOUT_MODE', mode);
    },
    ToggleFixedHeader({ commit }, fixedHeader) {
      if (!fixedHeader) {
        commit('TOGGLE_FIXED_HEADER_HIDDEN', false);
      }
      commit('TOGGLE_FIXED_HEADER', fixedHeader);
    },
    ToggleFixSiderbar({ commit }, fixSiderbar) {
      commit('TOGGLE_FIXED_SIDERBAR', fixSiderbar);
    },
    ToggleFixedHeaderHidden({ commit }, show) {
      commit('TOGGLE_FIXED_HEADER_HIDDEN', show);
    },
    ToggleContentWidth({ commit }, type) {
      commit('TOGGLE_CONTENT_WIDTH', type);
    },
    ToggleColor({ commit }, color) {
      commit('TOGGLE_COLOR', color);
    },
    ToggleWeak({ commit }, weakFlag) {
      commit('TOGGLE_WEAK', weakFlag);
    },
    ToggleMultiTab({ commit }, bool) {
      commit('TOGGLE_MULTI_TAB', bool);
    },
    ToggleSearchMemu({ commit }, bool) {
      commit('TOGGLE_SEARCH_MENU', bool);
    },
    TogglePermission({ commit }, bool) {
      commit('TOGGLE_PERMISSION', bool);
    },
    ToggleNavMenu({ commit }, bool) {
      commit('TOGGLE_NAV_MENU', bool);
    },
    ToggleShowChangeColor({ commit }, bool) {
      commit('TOGGLE_SHOW_CHANGE_COLOR', bool);
    },
    ToggleShowChangeLanguage({ commit }, bool) {
      commit('TOGGLE_SHOW_CHANGE_LANGUAGE', bool);
    },
    ToggleShowTips({ commit }, bool) {
      commit('TOGGLE_SHOW_TIPS', bool);
    },

    setLang({ commit }, lang) {
      // dbUser.setlang({ lang });
      return new Promise((resolve, reject) => {
        commit(APP_LANGUAGE, lang);
        loadLanguageAsync(lang)
          .then(() => {
            resolve();
          })
          .catch((e) => {
            reject(e);
          });
      });
    },
  },
};

export default app;
